import { render, staticRenderFns } from "./SnapshotsTab.vue?vue&type=template&id=adaa33c6&scoped=true&"
import script from "./SnapshotsTab.vue?vue&type=script&lang=ts&"
export * from "./SnapshotsTab.vue?vue&type=script&lang=ts&"
import style0 from "./SnapshotsTab.vue?vue&type=style&index=0&id=adaa33c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adaa33c6",
  null
  
)

export default component.exports